// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"90e8de80","977":"fcbac27c"}[chunkId] + ".chunk.js";
};